import { useMemo } from "react";
import { useSearchParams } from "react-router";

type IAddPickedTree = {
  unitId: number | null;
  mlId: number | null;
  partId: number | null;
};

type SetPickedTree = (
  updater: IAddPickedTree | ((prev: IAddPickedTree) => IAddPickedTree)
) => void;

function parseParam(param: string | null): number | null {
  if (param === null) return null;
  const parsed = Number(param);
  return isNaN(parsed) ? null : parsed;
}

export function usePickedTreeFromUrl(): [IAddPickedTree, SetPickedTree] {
  const [searchParams, setSearchParams] = useSearchParams();

  const pickedTree = useMemo<IAddPickedTree>(() => ({
    unitId: parseParam(searchParams.get("unitId")),
    mlId: parseParam(searchParams.get("mlId")),
    partId: parseParam(searchParams.get("partId")),
  }), [searchParams]);

  const setPickedTree: SetPickedTree = (updater) => {
    const nextPickedTree =
      typeof updater === "function" ? updater(pickedTree) : updater;

    const newParams = new URLSearchParams(searchParams);

    if (nextPickedTree.unitId != null) newParams.set("unitId", String(nextPickedTree.unitId));
    else newParams.delete("unitId");

    if (nextPickedTree.mlId != null) newParams.set("mlId", String(nextPickedTree.mlId));
    else newParams.delete("mlId");

    if (nextPickedTree.partId != null) newParams.set("partId", String(nextPickedTree.partId));
    else newParams.delete("partId");

    setSearchParams(newParams);
  };

  return [pickedTree, setPickedTree];
}
